import { getValue } from '../../components/values/Get';
import { FormConfig, FormValues } from '@topdanmark-onlinesolutions/claim-form-types';
import { CustomPageValidatorFn } from '../../types/custom-page-validator';

export const customPageValidation: CustomPageValidatorFn = (
    formValues: FormValues | undefined,
    formConfig: FormConfig | undefined
) => {
    if (!formValues || !formConfig) {
        return false;
    }

    const damageToPerson = getValue(formConfig, formValues, 'whichPersonsWereInjured');
    const damageToVehicle = getValue(formConfig, formValues, 'whichVehiclesWereDamaged');
    const damageToOther = getValue(formConfig, formValues, 'whichOtherStuffWasDamaged');

    // if at least 1 option is checked
    if (
        (damageToPerson && damageToPerson.length) ||
        (damageToVehicle && damageToVehicle.length) ||
        (damageToOther && damageToOther.length)
    ) {
        return true;
    }

    return false;
};
